import { format } from 'date-fns';
import React from 'react';
import { Column } from '../../../../hooks/useTablePages';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { JobItem } from './Jobs.query';
import Icon from '../../../../components/Icon/Icon';
import { Flex } from 'rebass';

export const columns: Column[] = [
  {
    header: 'Job',
    id: 'id',
    accessor: (row: JobItem) => {
      return (
        <Flex flexDirection="row" alignItems="center" sx={{ gap: 1 }}>
          {row.id}
          {row?.attachments?.length && (
            <Icon title={'Has photos'} icon="image" size="16" />
          )}
        </Flex>
      );
    },
    stringAccessor: (row) => row.id,
    width: 100,
  },
  {
    header: 'Site',
    accessor: 'recycledWaterInspection.waterSite.name',
    width: 200,
  },
  {
    header: 'Status',
    id: 'status',
    accessor: (row: JobItem) => {
      return constantToLabel(row.status);
    },
    width: 100,
  },
  {
    header: 'Assigned to',
    accessor: 'recycledWaterInspection.assignedTo.name',
    width: 140,
  },
  {
    header: 'Created',
    id: 'created',
    accessor: (row: JobItem) => {
      return format(row.created, 'M/d/yyyy');
    },
    width: 100,
  },
  {
    header: 'Contact',
    accessor: 'recycledWaterInspection.contact.name',
    width: 190,
  },
  {
    header: 'Contact Phone',
    id: 'recycledWaterInspection.contact.phones.value',
    accessor: (row: JobItem) => {
      return row.recycledWaterInspection?.contact?.phones[0]?.value ?? '';
    },
    width: 130,
  },
  {
    header: 'Supervisor',
    accessor: 'recycledWaterInspection.supervisor.name',
    width: 190,
  },
  {
    header: 'Super. Phone',
    id: 'recycledWaterInspection.contact.supervisor.value',
    accessor: (row: JobItem) => {
      return row.recycledWaterInspection?.supervisor?.phones[0]?.value ?? '';
    },
    width: 130,
  },
  // {
  //  header: 'Test Date',
  //   id: 'job.backflowTest.dateTested',
  //   accessor: (row: JobItem) => {
  //     if (!row.job.backflowTest?.dateTested) {
  //       return ''
  //     }
  //     return format(parseISO(row.job.backflowTest.dateTested), 'M/d/yyyy')
  //   },
  //   width: 100,
  // },
  {
    header: 'Address',
    id: 'address.street1',
    accessor: (row: JobItem) =>
      row.address.street1 +
      (row.address.street2 ? ', ' + row.address.street2 : ''),
    width: 250,
  },
  {
    header: 'City',
    accessor: 'address.city',
    width: 120,
  },
  {
    header: 'State',
    accessor: 'address.state',
    width: 80,
  },
  {
    header: 'Zip',
    id: 'address.zip',
    accessor: (row: JobItem) =>
      row.address.zip + (row.address.zipExt ? '-' + row.address.zipExt : ''),
    width: 120,
  },
];
